import { device } from "@src/theme";
import styled from "styled-components";

export const FileDropzoneContainer = styled.div<{
  $isDraggingFile?: boolean;
  dashed?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  opacity: ${({ disabled }): string => (disabled ? "0.5" : "1")};
  border: 2px ${({ dashed }) => (dashed ? "dashed" : "solid")}
    ${({ theme }): string => theme.colors.yellow};
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  background-color: ${({ theme, $isDraggingFile }): string =>
    $isDraggingFile ? theme.colors.darkBg : theme.colors.darkGray};
  &:hover {
    background-color: ${({ theme }): string => theme.colors.darkBg};
  }
`;

export const FileDropzoneInput = styled.input`
  display: none; // Hide the actual file input
`;
export const FileDropzoneLabel = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
export const FileDropzoneIcon = styled.div`
  color: ${({ theme }): string => theme.colors.yellow};
  margin-bottom: ${({ theme }): string => theme.margins.small};
`;

export const FileDropzoneText = styled.span`
  padding-left: 10px;
  padding-right: 10px;
  font-size: 1rem;
  color: ${({ theme }): string => theme.colors.yellow};
  text-align: center;
  font-weight: bold;

  @media ${device.mobile} {
    display: none;
  }
`;
